import React, { Component } from "react";

export default class CustomerList extends Component {

  render() {
    const { customers, customerIsLoading, selectedCustomer } = this.props;
    console.log(customers)

    if (customerIsLoading) {
      return (
        <div className="col-xl-12 my-auto text-center">
          <span className="spinner-border spinner-border-sm"></span>
        </div>
      );
    } else {
      return (
        <ul className="list-group list-group-flush w-100">
          {customers && customers.length && customers.map((customer, index) => (
            <li
              key={index}
              className={`list-group-item ${
                customer.customer === selectedCustomer ? "active" : ""
              } ${customer.new ? "new" : ""}`}
              onClick={() => this.props.selectCustomer(customer.customer)}
            >
              {customer.customer}{" "}
            </li>
          ))}
        </ul>
      );
    }
  }
}
